import { apiClient } from "@/services/apiClient";

export type PlatformMetricsOverview = {
  generatedAt: string;
  rangeBoundaries: {
    todayStart: string;
    weekStart: string;
    monthStart: string;
  };
  tenants: {
    total: number;
    activelyOnboarded: number;
    onboardedThisWeek: number;
    onboardingPending: number;
    recentOnboardings: Array<{
      id: string;
      name: string | null;
      legalName: string | null;
      rut: string;
      planId: string | null;
      onboardingCompletedAt: string;
    }>;
    byPlan: Array<{ planId: string | null; count: number }>;
  };
  invoices: {
    today: number;
    thisWeek: number;
    thisMonth: number;
    topTenantsByMonth: Array<{
      tenantId: string;
      tenantName: string | null;
      legalName: string | null;
      rut: string;
      count: number;
    }>;
  };
  dgi: {
    weekByDgiStatus: Array<{ dgiStatus: string; count: number }>;
  };
  mobile: {
    dau: number;
    wau: number;
    mau: number;
    activeInstalls: number;
    everSignedIn: number;
  };
};

/** Root-only platform-wide analytics snapshot. */
export async function getPlatformMetricsOverview(): Promise<PlatformMetricsOverview> {
  const { data } = await apiClient.get<PlatformMetricsOverview>(
    "/platform/metrics/overview",
  );
  return data;
}
